import ko from "knockout";
import $ from "jquery";

// Yes, it's a bit ugly - each div is a spoke in the animation wheel.
// See the style guide for implementation details
const LOADER_CONTENT_MARKUP =
    '<div class="load-indicator load-indicator-flex load-indicator-md"><gux-radial-progress class="gux-load-indicator" /></div>';

ko.bindingHandlers.loadIndicator = {
    init: function (element, valueAccessor) {
        const isLoading = ko.unwrap(valueAccessor());

        $(element).append(LOADER_CONTENT_MARKUP).toggle(isLoading);
    },
    update: function (element, valueAccessor) {
        const isLoading = ko.unwrap(valueAccessor());
        $(element).toggle(isLoading);
    },
};
